import Pagination from "@atlaskit/pagination";
import React from "react";
import { useDispatch } from "react-redux";
import { fetchPage } from "../../../../redux/reducers/TemplateField";

type Props = {
  selectedPage: number;
  numPages: number;
};
export const PaginationWrapper: React.SFC<Props> = ({
  numPages,
  selectedPage,
}) => {
  const dispatch = useDispatch();

  const [pages, setPages] = React.useState<number[]>([]);

  React.useEffect(() => {
    setPages(
      Array.from(Array(parseInt(numPages.toString(), 10)).keys()).map(
        (x) => x + 1
      )
    );
  }, [numPages]);

  return (
    <Pagination
      max={5}
      pages={pages}
      selectedIndex={parseInt(selectedPage.toString(), 10)}
      onChange={(e, pageNumber) => {
        dispatch(fetchPage({ pageNumber: pageNumber - 1 }));
      }}
    ></Pagination>
  );
};
export default PaginationWrapper;
